import controller from './list.controller';
import template from './list.pug';

const ListComponent = {
  template,
  controller,
};

export default ListComponent;



// WEBPACK FOOTER //
// ./client/app/cases/list/list.component.js